import styled from "@emotion/styled";
import { alpha, ListItemButton as MuiListItemButton } from "@mui/material";

const ListItemButton = styled(MuiListItemButton)({
  marginTop: "10px",
  padding: "0px 0px 0px 0px !important",
  borderRadius: "10px",
  "&.Mui-selected": {
    backgroundColor: "#203864",
    color: "#fff",
    borderRadius: "10px",
    padding: "0px 0px 0px 0px !important",
    "&:hover": {
      backgroundColor: "#203864",
      color: "#fff",
    },
  },
  "&:hover": {
    backgroundColor: alpha("#203864", 0.2),
    borderRadius: "10px",
  },
});

export default ListItemButton;